import { applySnapshot, getSnapshot, types, type Instance } from 'mobx-state-tree'
// react-fast-compare is based on fast-deep-equal but is actively maintained. There may be a leaner package that does this.
import isEqual from 'react-fast-compare'

export const IsEditingModel = types
  .model('IsEditingModel')
  .views((self) => ({
    get snapshot() {
      return getSnapshot(self)
    },
  }))
  .volatile((self) => ({
    isEditing: false,
    initialSnapshot: self.snapshot,
  }))
  .actions((self) => ({
    setIsEditing(isEditing: typeof self.isEditing): void {
      self.isEditing = isEditing
    },
  }))
  .views((self) => ({
    get isDirty(): boolean {
      return !isEqual(self.initialSnapshot, self.snapshot)
    },
  }))
  .actions((self) => ({
    discardChanges() {
      applySnapshot(self, self.initialSnapshot)
    },
  }))

type IsEditingModelType = Instance<typeof IsEditingModel>

export interface IsEditingModelInstance extends Instance<IsEditingModelType> {}